import { render, staticRenderFns } from "./SupplierListCreate.vue?vue&type=template&id=5afb073c&scoped=true"
import script from "./SupplierListCreate.vue?vue&type=script&lang=js"
export * from "./SupplierListCreate.vue?vue&type=script&lang=js"
import style0 from "./SupplierListCreate.vue?vue&type=style&index=0&id=5afb073c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb073c",
  null
  
)

export default component.exports